/** Rodapé minimalista — reaproveita a assinatura de apps/site/landing-antiga.html. */
export function Rodape(): JSX.Element {
  const ano = new Date().getFullYear();

  return (
    <footer className="border-auth-borda/8 border-t py-10">
      <div className="mx-auto flex max-w-6xl flex-col gap-3 px-6 text-sm sm:flex-row sm:items-center sm:justify-between">
        <p className="text-auth-texto-secundario max-w-md">
          <strong className="text-auth-texto font-medium">Specializer Social</strong> —
          gestão de atos societários para escritórios de contabilidade. Feito no norte do
          Paraná.
        </p>
        <p className="text-auth-texto-terciario font-mono text-xs">
          social.specializer.com.br · © {ano}
        </p>
      </div>
    </footer>
  );
}
